import {inject, Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../auth';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  urls: string[] = ['geolocation-db.com', 'amazonaws.com'] as const;
  private readonly _auth = inject(AuthenticationService);

  /** Intercept all HTTP requests and add JWT token to the Authorization header */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const userToken = this._auth.getToken();
    const isUrlExcluded = this.urls.some(url => request.url.includes(url));
    if (userToken && !isUrlExcluded) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${userToken}`
        }
      });
    }
    return next.handle(request);
  }
}
